/**
 * @generated SignedSource<<025b00e9b31b73f237130d2a69699587>>
 * @relayHash 20688ce23e5e858cfc82d72bb57f43b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c

import type { ConcreteRequest } from 'relay-runtime';
export type MediaUploadTokenQuery$variables = {
  contentId: string;
};
export type MediaUploadTokenQuery$data = {
  readonly contentMediaSession: {
    readonly collection: string;
    readonly configuration: {
      readonly clientId: string;
      readonly fileStoreUrl: string;
    };
    readonly token: {
      readonly value: string;
    };
  } | null;
};
export type MediaUploadTokenQuery = {
  response: MediaUploadTokenQuery$data;
  variables: MediaUploadTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentMediaSession",
    "kind": "LinkedField",
    "name": "contentMediaSession",
    "plural": false,
    "selections": [
      {
        "concreteType": "MediaToken",
        "kind": "LinkedField",
        "name": "token",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "value"
          }
        ]
      },
      {
        "concreteType": "MediaConfiguration",
        "kind": "LinkedField",
        "name": "configuration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "clientId"
          },
          {
            "kind": "ScalarField",
            "name": "fileStoreUrl"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "collection"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "MediaUploadTokenQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MediaUploadTokenQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "20688ce23e5e858cfc82d72bb57f43b8",
    "id": "6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c",
    "metadata": {},
    "name": "MediaUploadTokenQuery",
    "operationKind": "query",
    "text": "query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
  }
};
})();

(node as any).hash = "1f89a4aaada59e040e6317ae1cdc704c";

export default node;
